import React from "react"
import types from "prop-types"
import { HiddenSideTabs } from "shared/tabs"
import { useSelector } from "react-redux"
import {
  currentUserIsInAdminRole as getCurrentUserIsInAdminRole,
} from "reduxSlices/sessionSlice"
import { isFeatureEnabled } from "reduxSlices/featuresSlice"
import { subscribedToAddOnFeature } from "reduxSlices/addOnFeatureSubscriptionsSlice"
import { REPORT_SFTP_FEATURE_NAME } from "utils/addOnFeatureHelpers"
import { ORG_OPTIONS_LISTS } from "utils/featuresHelpers"
import { tabSlugFromQueryParams } from "utils/tabHelper"
import {
  GENERAL_SETTINGS_ANSWER_OPTIONS_TAB_SLUG,
  GENERAL_SETTINGS_FACILITY_GROUP_CODES_TAB_SLUG,
  GENERAL_SETTINGS_GENERAL_TAB_SLUG,
  GENERAL_SETTINGS_QUESTION_TAGS_TAB_SLUG,
  GENERAL_SETTINGS_SFTP_SETTINGS_TAB_SLUG,
} from "utils/tabSlugHelpers"
import FacilityGroupCodesTab, { useFacilityGroupCodesTabHeading } from "./FacilityGroupCodesTab"
import GeneralTab, { GENERAL_TAB_HEADING } from "./GeneralTab"
import QuestionTagsTab, { QUESTION_TAGS_TAB_HEADING } from "./QuestionTagsTab"
import SFTPSettingsTab, { SFTP_SETTINGS_TAB_HEADING } from "./SFTPSettingsTab"
import AnswerOptionsTab, { ANSWER_OPTIONS_TAB_HEADING } from "./AnswerOptionsTab"

const SFTPTab = {
  title: SFTP_SETTINGS_TAB_HEADING,
  slug: GENERAL_SETTINGS_SFTP_SETTINGS_TAB_SLUG,
  TabContent: SFTPSettingsTab,
}

const AnswerOptionsTabObject = {
  title: ANSWER_OPTIONS_TAB_HEADING,
  slug: GENERAL_SETTINGS_ANSWER_OPTIONS_TAB_SLUG,
  TabContent: AnswerOptionsTab,
}

const GeneralSettingsTabs = ({ tabProps = {} }) => {
  const currentUserIsInAdminRole = useSelector(getCurrentUserIsInAdminRole)
  const organizationSubscribedToSFTPFeature = useSelector(
    subscribedToAddOnFeature(REPORT_SFTP_FEATURE_NAME),
  )
  const orgOptionsListsFeatureEnabled = useSelector(isFeatureEnabled(ORG_OPTIONS_LISTS))
  const facilityGroupCodesTabHeading = useFacilityGroupCodesTabHeading()

  const showSFTPTab = organizationSubscribedToSFTPFeature && currentUserIsInAdminRole
  const showAnswerOptionsTab = orgOptionsListsFeatureEnabled && currentUserIsInAdminRole

  const allTabs = [
    {
      title: GENERAL_TAB_HEADING,
      slug: GENERAL_SETTINGS_GENERAL_TAB_SLUG,
      TabContent: GeneralTab,
      props: tabProps,
    },
    {
      title: QUESTION_TAGS_TAB_HEADING,
      slug: GENERAL_SETTINGS_QUESTION_TAGS_TAB_SLUG,
      TabContent: QuestionTagsTab,
      props: tabProps,
    },
    ...(showAnswerOptionsTab ? [AnswerOptionsTabObject] : []),
    {
      title: facilityGroupCodesTabHeading,
      slug: GENERAL_SETTINGS_FACILITY_GROUP_CODES_TAB_SLUG,
      TabContent: FacilityGroupCodesTab,
      props: tabProps,
    },
    ...(showSFTPTab ? [SFTPTab] : []),
  ]

  return (
    <HiddenSideTabs tabs={allTabs} initialActiveSlug={tabSlugFromQueryParams()} />
  )
}

GeneralSettingsTabs.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  tabProps: types.object,
}

export default GeneralSettingsTabs
